import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-tooltip"]
const _hoisted_2 = {
  key: 0,
  class: "status__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.type)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["status__container", `${_ctx.typeMap[_ctx.type]} display__${_ctx.display} position__${_ctx.position} ${_ctx.parsedTooltip && 'has-tooltip'}`]),
        "data-tooltip": _ctx.parsedTooltip
      }, [
        _renderSlot(_ctx.$slots, "default", {
          type: _ctx.type,
          typeMap: _ctx.typeMap,
          label: _ctx.parsedLabel,
          tooltip: _ctx.parsedTooltip
        }, () => [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "indicator" }, null, -1)),
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true)
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}